import * as yup from 'yup';
import { Fields } from '~/features/checkout/models/fields';
import { useTranslation } from '~/shared/utils/translation';
import {
    isGender,
    isName,
    isAddress1,
    isZipCode,
    isPhoneWithoutCountryCode,
} from '~/utils/form-validators';

/**
 * Yup documentaion https://github.com/jquense/yup
 * @returns validation schema
 */

export const useValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.Email]: yup.string().email(translate('message.emailValidationError')).required(''),

        [Fields.Phone]: yup
            .string()
            .required('')
            .matches(/^[0-9]{8,10}$/, translate('message.phoneValidationError'))
            .matches(isPhoneWithoutCountryCode, translate('message.phoneValidationError')),

        [Fields.FirstName]: yup
            .string()
            .required('')
            .matches(
                isName,
                translate('message.firstnameValidationError') ||
                    'Fornavn må kun indeholde bogstaver, mellemrum, komma, punktum og bindestreg',
            )
            .trim(),

        [Fields.LastName]: yup
            .string()
            .required('')
            .matches(
                isName,
                translate('message.lastnameValidationError') ||
                    'Efternavn må kun indeholde bogstaver, mellemrum, komma, punktum og bindestreg',
            )
            .trim(),

        [Fields.Gender]: yup
            .string()
            .required('')
            .matches(isGender, 'Personens køn skal angives')
            .trim(),

        [Fields.Address1]: yup
            .string()
            .required('')
            .matches(isAddress1, translate('message.addressMissingHouseNumber'))
            .max(50, translate('message.addressLengthValidationError')),

        [Fields.PostalCode]: yup
            .string()
            .required('')
            .matches(isZipCode, translate('message.postNumberValidationError')),

        [Fields.City]: yup.string().required(''),
    });
};
